export const REASONS_IN_ORDER = [
  "failed to load bidding strategy predictors",
  "request predictors are empty",
  "campaign audience is publisher app",
  "campaign rate limiting for audience similarity tensorflow prediction",
  "impression rate on campaign publisher combination is too low",
  "no active platform fee deal",
  "campaign is not associated with a budget pool",
  "campaign budget is not active",
  "campaign budget split is nil",
  "campaign budget split is not active",
  "campaign is out of budget",
  "invalid advertiser url",
  "category is blocked",
  "campaign has no ads",
  "excluded because user is already part of the audience",
  "rule did not match",
  "rule has invalid child rule",
  "rule has invalid operator",
  "left hand side rule is nil",
  "left hand side rule is invalid",
  "right hand side rule is nil",
  "right hand side rule is invalid",
  "context object for dynamic rule is invalid",
  "all rules matched",
  "resold traffic blocked",
  "campaign experiment not running",
  "randomization unit is empty",
  "not selected as a campaign experiment variant",
  "fraud protection - user impression limit reached",
  "fraud protection - user click limit reached",
  "user history is invalid",
  "campaign has no valid ads",
  "error during custom code parsing",
  "precondition in custom code violated",
  "error during custom code execution",
  "failed to select an ad",
  "skan settings evaluation error",
  "skan settings do not match for partner",
  "Bid spike detected; rate limited until next minute",
  "Campaign is overdelivering (spend rate exceeds stop rate)",
  "Audience similarity predictor returned an error",
  "Audience similarity score is too low",
  "Bid probability throttling (random slow down)",
  "Campaign spend rate is NaN",
  "Budget spend rate is NaN",
  "Unknown stop delivery reason",
  "failed to predict budget distribution",
  "bid probability throttled by virtual budgets",
  "budget distribution produced invalid NaN spend rate",
  "bidding strategy budget distribution over delivery",
  "bidding strategy budget distribution slow down bidprobability",
  "audience similarity predictor returned low score",
  "error during audience similarity predictor execution",
  "campaign passed filter step",
  "error in bidding strategy",
  "campaign passed all filter",
];

export const PASS_REASONS = [
  "Bidding Flow",
  "all rules matched",
  "campaign passed filter step",
  "campaign passed all filter",
];
